module.exports = __webpack_public_path__ + "static/media/Sabbir_03.8339005c.jpg";